module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_null.0104b781.png";